import { action } from 'satcheljs';
import type { SearchServiceEventMap } from '@metaos/hub-sdk';

export interface OnAppAddSearchEventListenerActionMessage {
    eventName: keyof SearchServiceEventMap;
    eventListener: any;
}
const onAppAddSearchEventListener: (
    eventName: keyof SearchServiceEventMap,
    eventListener: any
) => OnAppAddSearchEventListenerActionMessage = action(
    'onAppAddSearchEventListener',
    (
        eventName: keyof SearchServiceEventMap,
        eventListener: any
    ): OnAppAddSearchEventListenerActionMessage => ({ eventName, eventListener })
);
export default onAppAddSearchEventListener;
